<template>
    <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div class="card rounded-8">
                <img
                    class="card-img-top"
                    src="/images/preview_bootcamps.jpg"
                    alt="Card image cap"
                />
                <div class="card-body">
                    <div class="mb-3">
                        <span
                            class="badge badge-secondary text-primary bg-utel-v2-secondary"
                            >Ruta</span
                        >
                    </div>
                    <div class="text-card-normal mb-3">
                        <h5 class="card-title" style="height: 57px">
                            {{ info.ruta.name }}
                        </h5>
                        <small
                            ><i
                                class="fa-solid fa-book-open text-secondary"
                            ></i>
                            4 a 6 cursos&nbsp;|&nbsp;
                            <i class="fa-solid fa-clock text-secondary"></i>
                            6 a 10 horas</small
                        >
                        <p class="card-text short-description-diploma">
                            {{ info.ruta.description }}
                        </p>
                    </div>
                    <ul class="text-dark small list-courses-description">
                        <li
                            v-for="(curso, index) of info.ruta.courses"
                            :key="index"
                        >
                            <a href="javascript:void(0);"
                                ><span
                                    class="text-dark"
                                    :title="stripHtml(curso.post_content)"
                                    >{{ curso.post_title }}</span
                                ></a
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <label>Ruta seleccionada:</label>
            <p>
                {{ info.ruta.name }}
                <i
                    class="fa-regular fa-pen-to-square cursor-pointer"
                    @click="changePaso(1)"
                ></i>
            </p>
            <label
                >Usuarios inscritos: {{ info.users.length }}
                <i
                    class="fa-regular fa-pen-to-square cursor-pointer"
                    @click="changePaso(2)"
                ></i
            ></label>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
            <div class="col-12 mb-0">
                <label for="info-tiempo"><b>Tiempo de vigencia</b></label>
                <input
                    type="number"
                    id="info-tiempo"
                    placeholder="Tiempo en número"
                    v-model.number="info.ruta.validity_time"
                    class="form-control rounded-8 sin-borde"
                />
                <small v-if="errors.validity_time" class="text-danger"
                    >Debe ingresar un número.</small
                >
            </div>
            <div class="col-12 mb-0">
                <label for="type_period"><b>Tipo de tiempo</b></label>
                <select
                    class="form-control rounded-8 sin-borde"
                    v-model="info.ruta.type_period"
                    id="type_period"
                >
                    <option value="">Seleccione una opción</option>
                    <option
                        v-for="period in periodTypes"
                        :key="period.value"
                        :value="period.value"
                    >
                        {{ period.label }}
                    </option>
                </select>
                <small v-if="errors.type_period" class="text-danger"
                    >Debe seleccionar una opción.</small
                >
            </div>
            <button
                class="btn bg-utel-v2-secondary text-primary sin-borde rounded-8 px-5"
                :disabled="isCreating"
                @click="agregarRuta"
            >
                <span
                    v-if="isCreating"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                ></span>
                {{ isCreating ? "Creando ruta..." : "Crear ruta" }}
            </button>
        </div>

        <modalconfirmation
            v-if="showConfirmation"
            :url_redirect="url_redirect"
        ></modalconfirmation>
    </div>
</template>

<script>
import modalconfirmation from "../modals/ModalConfirmation.vue";

export default {
    name: "DefaultRoutesConfirmation",
    components: { modalconfirmation },
    props: {
        info: { type: Object, required: true },
        url_get: { type: String, required: true },
        empresa_elegida: { type: [String, Object], default: "" },
        url_redirect: { type: String, required: true },
    },
    emits: ["changeStep"],
    data() {
        return {
            showConfirmation: false,
            isCreating: false,
            errors: { validity_time: false, type_period: false },
            periodTypes: [
                { value: "horas", label: "Horas" },
                { value: "dias", label: "Días" },
                { value: "meses", label: "Meses" },
            ],
        };
    },
    mounted() {
        if (!this.info.ruta.type_period) {
            this.info.ruta.type_period = "";
        }
    },
    methods: {
        stripHtml(html) {
            return html?.replace(/<\/?[^>]+(>|$)/g, "") || "";
        },
        changePaso(step) {
            this.$emit("changeStep", [step, this.info.ruta, this.info.users]);
        },
        validateForm() {
            this.errors.validity_time = !this.info.ruta.validity_time;
            this.errors.type_period = !this.info.ruta.type_period;
            return !this.errors.validity_time && !this.errors.type_period;
        },
        getSubmitUrl() {
            const baseUrl = this.empresa_elegida?.routes || this.url_get;
            return `${baseUrl}?suggest=true`;
        },
        async agregarRuta() {
            if (!this.validateForm()) return;

            this.isCreating = true;

            try {
                const ruta = {
                    newClient: {
                        ...this.info.ruta,
                        students: this.info.users,
                        cursos: this.info.courses,
                    },
                };
                await axios.post(this.getSubmitUrl(), ruta);
                this.showConfirmation = true;
            } catch (error) {
                console.error("Error al crear ruta:", error);
            } finally {
                this.isCreating = false;
            }
        },
    },
};
</script>
